import { createApp } from 'vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import router from './router'
import { createPinia } from 'pinia'
import './permission'
import LangManager from '@/utils/langManager'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'

import pcApp from './App.vue';
import mobileApp from './App-mobile.vue';


// let App;
import { isMobile } from './utils/common'

console.log('isMobile', isMobile, isMobile ? mobileApp : pcApp)
const app = createApp(isMobile ? mobileApp : pcApp)

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}

app.use(ElementPlus)
app.use(router)
app.use(createPinia())
app.use(LangManager.i18n)

app.mount('#app')

